import { type LandingBenefit, type LandingQuestion, type LandingSection, type LandingStep } from '@ui/landing'
import { ChartBarIncreasingIcon, InboxIcon, LockIcon, SearchIcon, StarIcon, TagIcon } from 'lucide-react'

/**
 * Тексты лендинга. Держим их отдельно от разметки: правки в них случаются чаще, чем правки
 * вёрстки, и так их видно списком, не разбирая JSX.
 */

/** Нумерация здесь не украшение: это порядок, в котором фулфилмент проходит путь до первой заявки. */
export const steps: LandingStep[] = [
  {
    title: 'Заполняете карточку',
    text: 'Услуги и цены, города складов, маркетплейсы и схемы работы, фотографии. Заполняете один раз — и потом правите когда угодно.',
    note: 'Без договора и без платы',
  },
  {
    title: 'Карточка встаёт в каталог',
    text: 'Сначала её смотрит наша поддержка, обычно в течение дня. После этого карточка попадает в общий список, в разделы по схемам работы и в страницы городов. И получает отдельный адрес в поиске Яндекса и Google.',
    note: 'Плюс рейтинг с Карт и 2ГИС',
  },
  {
    title: 'Продавцы присылают заявки',
    text: 'В заявке уже указано, что за товар, сколько его, откуда забирать и на какую площадку отгружать. Вы отвечаете ценой.',
    note: 'Отказ — в одно нажатие',
  },
]

export const benefits: LandingBenefit[] = [
  {
    icon: InboxIcon,
    title: 'Заявки с деталями, а не «здравствуйте»',
    text: 'Продавец описывает товар, объёмы, город и площадку до начала разговора. Не подходит — отказ в одно нажатие, заявка уходит другим.',
  },
  {
    icon: TagIcon,
    title: 'Цены видно сразу',
    text: 'Приёмка, упаковка, маркировка, хранение — прайс стоит прямо в карточке. Приходят те, кого ваши условия уже устроили.',
  },
  {
    icon: StarIcon,
    title: 'Оценки подтягиваются сами',
    text: 'Есть страница на Яндекс Картах или в 2ГИС — рейтинг и отзывы оттуда появятся в карточке и будут обновляться без вас.',
  },
  {
    icon: SearchIcon,
    title: 'Отдельная страница в поиске',
    text: 'У карточки свой адрес, заголовки и разметка для поисковиков. Её находят не только внутри Evirma.',
  },
  {
    icon: ChartBarIncreasingIcon,
    title: 'Видно, что происходит',
    text: 'Считаются просмотры карточки и переходы к контактам. Понятно, работает размещение или его пора дополнить.',
  },
  {
    icon: LockIcon,
    title: 'Карточка остаётся вашей',
    text: 'Цены, контакты и услуги меняете только вы. Карточку вашей компании, заведённую кем-то другим, можно забрать себе.',
  },
]

export const questions: LandingQuestion[] = [
  {
    question: 'Сколько стоит размещение?',
    answer:
      'Нисколько. Карточка, показ в каталоге и заявки от продавцов бесплатны. Отдельной платы за отклик на заявку тоже нет.',
  },
  {
    question: 'Кто увидит мои контакты?',
    answer:
      'Телефон, почта и мессенджеры открываются по нажатию — так мы отсекаем сбор контактов роботами. Продавцу для этого ничего дополнительно делать не нужно.',
  },
  {
    question: 'Мою компанию добавили без меня. Что делать?',
    answer:
      'Откройте карточку и нажмите «Это мой фулфилмент». Мы проверим и передадим карточку вам вместе с правом менять цены и контакты.',
  },
  {
    question: 'У нас нет склада в каждом городе. Это помешает?',
    answer:
      'Нет. Города складов и география работы задаются отдельно: продавец увидит, откуда вы забираете товар и куда отгружаете, и не будет писать зря.',
  },
  {
    question: 'Можно убрать карточку из каталога?',
    answer:
      'Да. Напишите нам через «Сообщить об ошибке» в своей карточке — мы уберём её из каталога. Цены, услуги и контакты вы правите сами в любой момент, без обращения.',
  },
]

/** Площадки, ради которых продавцы и ищут фулфилмент: строка под кнопками первого экрана. */
export const marketplaces = ['Wildberries', 'Ozon', 'Яндекс Маркет', 'Мегамаркет']

/** Разделы, до которых доводит липкая полоса навигации. */
export const sections: LandingSection[] = [
  { id: 'how-it-works', label: 'Как это работает' },
  { id: 'benefits', label: 'Что даёт карточка' },
  { id: 'faq', label: 'Вопросы' },
]
